import { RouteObject, createBrowserRouter } from 'react-router-dom'
import AppError from 'containers/App/AppError'
import { ProtectedPageShell } from 'containers/ProtectedPageShell'
import NotFound from '../pages/NotFound'
import routesMaps from './routesMap'

type TCreateRouterInit = {
  shell: React.ReactNode
  routerOptions: {
    basename: string
  }
}

const routerFactory = (init: TCreateRouterInit) => {
  const routeList: RouteObject[] = [
    {
      path: '/',
      element: init.shell,
      ErrorBoundary: AppError,
      children: [...routesMaps.protectedRoutes],
    },
    ...routesMaps.publicRoutes,
    {
      path: '*',
      element: <NotFound />,
    },
  ]

  const browserRouterResult = createBrowserRouter(routeList, {
    basename: init.routerOptions.basename,
  })

  return {
    router: browserRouterResult,
    routes: routeList,
  }
}

const { router, routes } = routerFactory({
  shell: <ProtectedPageShell />,
  routerOptions: { basename: '/' },
})
export { routes, routerFactory }
export default router
